export interface NavItem {
  displayName?: string;
  shortDescription?: string;
  Description?: string;
  tags?: string[];
  disabled?: boolean;
  block?: boolean;
  external?: boolean;
  twoLines?: boolean;
  chip?: boolean;
  iconName?: string;
  iconClass?: string;
  navCap?: string;
  chipContent?: string;
  chipClass?: string;
  subtext?: string;
  route?: string;
  queryParams?: Record<string, string>;
  children?: NavItem[];
  ddType?: string;
}

export function getNavItemRoutePath(route: string): string {
  return route.split("?")[0].split("#")[0];
}

export function getNavItemTrackId(item: NavItem): string {
  if (item.route) {
    return `route:${getNavItemRoutePath(item.route)}`;
  }

  if (item.navCap) {
    return `cap:${item.navCap}`;
  }

  const childrenKey =
    item.children
      ?.map((child) => getNavItemTrackId(child))
      .join("|") ?? "";

  if (item.displayName) {
    return childrenKey
      ? `group:${item.displayName}:${childrenKey}`
      : `name:${item.displayName}`;
  }

  return `icon:${item.iconName ?? "nav-item"}`;
}
